import React from 'react';

/** 0–max meter whose gradient always spans the full track (red → amber → green). */
export const ScoreBar: React.FC<{
  value: number;
  max?: number;
  label: string;
  /** Optional dotted tick, e.g. the score before deductions. */
  marker?: number;
}> = ({ value, max = 10, label, marker }) => {
  const pct = Math.max(0, Math.min(100, (value / max) * 100));
  return (
    <div className="score-bar" role="img" aria-label={label}>
      <span
        className="score-bar__fill"
        style={{ width: `${pct}%`, backgroundSize: `${pct > 0 ? 10000 / pct : 100}% 100%` }}
      />
      {marker != null && (
        <span className="score-bar__marker" style={{ left: `${Math.min(100, (marker / max) * 100)}%` }} />
      )}
    </div>
  );
};
